const customStyles = {
  control: base => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    border: 0,
    color: '#fff',
    height: 'auto',
    boxShadow: 'none',
    background: 'transparent',
    '&:hover': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none'
    }
  }),
  placeholder: base => ({
    ...base,
    color: '#fff',
    '&:hover': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none'
    }
  }),
  singleValue: base => ({
    ...base,
    color: '#fff',
    '&:hover': {
      boxShadow: 'none'
    },
    '&:focus': {
      boxShadow: 'none'
    }
  }),
  option: (base, { isDisabled, isSelected }) => ({
    ...base,
    color: isDisabled ? '#ccc' : isSelected ? '#fff' : '#000'
  }),
  input: base => ({
    ...base,
    color: '#fff'
  }),
  clearIndicator: base => ({
    ...base,
    cursor: 'pointer'
  }),
  dropdownIndicator: base => ({
    ...base,
    cursor: 'pointer'
  })
};

export default customStyles;
